import React from "react";
import {withTranslation} from "react-i18next";
import Calendar from "../../../../../../../components/calendar/Calendar";
import Utils from "../../../../../../../utils/Utils";
import Select from "../../../../../../../components/select/Select";
import Input from "../../../../../../../components/textbox/Input";
import OggettiUtili from "../../../../../../../utils/OggettiUtili";
import $ from "jquery";
import SessioneUtente from "../../../../../../../sessionManager/SessioneUtente";
import Ruoli from "../../../../../../../utils/Ruoli.json";


class DiagnosiMIB extends React.Component {

    state = {
        diagnosi: {
            personaDiagnosi: this.props.statePadre && this.props.statePadre.personaDiagnosi ? this.props.statePadre.personaDiagnosi : "",
            recapito: this.props.statePadre && this.props.statePadre.recapito ? this.props.statePadre.recapito : "",
            email: this.props.statePadre && this.props.statePadre.email ? this.props.statePadre.email : "",
            ospedale: this.props.statePadre && this.props.statePadre.ospedale ? this.props.statePadre.ospedale : "",
            dataDiagnosiMib: this.props.statePadre && this.props.statePadre.dataDiagnosiMib ? this.props.statePadre.dataDiagnosiMib : ""
        }

    }

    constructor(props) {
        super(props)

        this.riceviValore = this.riceviValore.bind(this);
        this.createOggettoBE = this.createOggettoBE.bind(this);
        this.validate = this.validate.bind(this);
        this.disabledCalendar = this.disabledCalendar.bind(this);
    }

    componentDidMount() {
        let oggetto = this.createOggettoBE()
        this.disabledCalendar();
        this.props.setDiagnosiMIB(this.state.diagnosi, "", oggetto)

        if(Utils.isEmpty(this.props.statePadre)) {
            if (this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.diagnosiMIB) {
                let diagnosi = this.state.diagnosi
                let diagnosiProps = this.props.segnalazioneCopia.schedaSpeciale.diagnosiMIB

                diagnosi.personaDiagnosi = diagnosiProps.personaDiagnosi ? diagnosiProps.personaDiagnosi : this.state.diagnosi.personaDiagnosi
                diagnosi.recapito = diagnosiProps.recapito ? diagnosiProps.recapito : this.state.diagnosi.recapito
                diagnosi.email = diagnosiProps.email ? diagnosiProps.email : this.state.diagnosi.email
                diagnosi.ospedale = diagnosiProps.ospedale ? diagnosiProps.ospedale : this.state.diagnosi.ospedale
                diagnosi.dataDiagnosiMib = diagnosiProps.dataDiagnosiMib ? diagnosiProps.dataDiagnosiMib : this.state.diagnosi.dataDiagnosiMib

                this.setState({diagnosi: diagnosi});

            }
        }

        oggetto = this.createOggettoBE()
        this.props.setDiagnosiMIB(this.state.diagnosi, "", oggetto)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState !== this.state) {
            let res = this.createOggettoBE()
            this.props.setDiagnosiMIB(this.state.diagnosi, this.validate(), res)
        }
    }

    disabledCalendar() {
        if ((this.props.segnalazioneCopia && this.props.segnalazioneCopia.migrazione) || SessioneUtente.getInstance().ruoliUtente !== Ruoli.Operatore_Laboratorio.descrizione || (this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
            this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice) || !this.props.malattiaBatterica) {
            $(document).ready(function () {
                $("#dataDiagnosiMib").datepicker('disable');
            })
        } else {
            $(document).ready(function () {
                $("#dataDiagnosiMib").datepicker('enable');
            })
        }
    }

    validate() {

        if (this.state.diagnosi.dataDiagnosiMib && Utils.validateDate(this.state.diagnosi.dataDiagnosiMib, "Messages.DataPrelievo", "Messages.DataPrelievoOdierna")) {
            return Utils.validateDate(this.state.diagnosi.dataDiagnosiMib, "Messages.DataPrelievo", "Messages.DataPrelievoOdierna")
        }

        return ""

    }

    createOggettoBE() {
        let diagnosi = JSON.parse(JSON.stringify(this.state.diagnosi))
        let diagnosiBe = Utils.removeEmptyValueFromObject(diagnosi)
        return diagnosiBe

    }

    riceviValore(field, event) {
        let diagnosi = this.state.diagnosi
        diagnosi[field] = event.target.value
        this.setState({diagnosi: diagnosi})

        let oggetto = this.createOggettoBE()
        this.props.setDiagnosiMIB(this.state.diagnosi, "", oggetto)
    }

    render() {

        const {t} = this.props;

        const sezione1 = (
            <div>
                <div className={"container"}>
                    <div className="row">
                        <div className="col-lg-5">
                            <p style={{fontWeight: "bold", marginTop: "10px"}}>
                                {t("SchedaFlussoSpeciale.MIB.Diagnosi.persona")}
                            </p>
                        </div>
                        <div className="col-lg-4">
                            <Input id={"personaDiagnosi"}
    onChange={this.riceviValore}
    field={"personaDiagnosi"}
    value={this.state.diagnosi.personaDiagnosi}
    placeholder={t("SchedaFlussoSpeciale.MIB.Diagnosi.persona")}/>
                        </div>
                    </div>

                    <div className="row" style={{paddingTop: "1rem"}}>
                        <div className="col-lg-5">
                            <p style={{fontWeight: "bold", marginTop: "10px"}}>
                                {t("SchedaFlussoSpeciale.MIB.Diagnosi.recapito")}
                            </p>
                        </div>
                        <div className="col-lg-4">
                            <Input id={"recapito"}
    onChange={this.riceviValore}
    field={"recapito"}
    value={this.state.diagnosi.recapito}
    placeholder={t("SchedaFlussoSpeciale.MIB.Diagnosi.recapito")}/>
                        </div>
                    </div>

                    <div className="row" style={{paddingTop: "1rem"}}>
                        <div className="col-lg-5">
                            <p style={{fontWeight: "bold", marginTop: "10px"}}>
                                {t("SchedaFlussoSpeciale.MIB.Diagnosi.email")}
                            </p>
                        </div>
                        <div className="col-lg-4">
                            <Input id={"email"}
    onChange={this.riceviValore}
    field={"email"}
    value={this.state.diagnosi.email}
    placeholder={t("SchedaFlussoSpeciale.MIB.Diagnosi.email")}/>
                        </div>
                    </div>


                    <div className="row" style={{paddingTop: "1rem"}}>
                        <div className="col-lg-5">
                            <p style={{fontWeight: "bold", marginTop: "10px"}}>
                                {t("SchedaFlussoSpeciale.MIB.Diagnosi.ospedale")}
                            </p>
                        </div>
                        <div className="col-lg-4">
                            <Select
                                field={"ospedale"}
                                value={this.state.diagnosi.ospedale}
                                onChange={this.riceviValore}
                                id={"ospedale"}
                                newSelect={true}
                                functionMap={Utils.mapToArray(OggettiUtili.LaboratorioDiagnosiMIB).map((oggetto) => {
                                    return (
                                        <option value={oggetto.codice}>{oggetto.descrizione}</option>)
                                })}

                            >
                            </Select>
                        </div>
                    </div>


                    <div className="row" style={{marginTop: "1rem"}}>
                        <div className="col-lg-5">
                            <p style={{fontWeight: "bold", marginTop: "10px"}}>
                                {t("SchedaFlussoSpeciale.MIB.Diagnosi.data")}
                            </p>
                        </div>
                        <div className="col-lg-4">
                            <Calendar
                                id={"dataDiagnosiMib"}
                                value={this.state.diagnosi.dataDiagnosiMib}
                                field={"dataDiagnosiMib"}
                                newCalendar={true}
                                disabled={(this.props.segnalazioneCopia && this.props.segnalazioneCopia.migrazione) || SessioneUtente.getInstance().ruoliUtente !== Ruoli.Operatore_Laboratorio.descrizione || (this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                                    this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice) || !this.props.malattiaBatterica}
                                onChange={this.riceviValore}
                                errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>", t("SchedaFlussoSpeciale.MIB.Diagnosi.data"))}
                                error={(this.state.diagnosi.data === "" || this.state.diagnosi.data == null) ? false :
                                    Utils.isDateInValid(Utils.transformDateForBackend(this.state.diagnosi.data), "-")
                                }
                            >
                            </Calendar>
                        </div>
                    </div>

                </div>
            </div>
        );

        return (
            <div>
                {sezione1}
            </div>

        )
    }

}

export default withTranslation('common')(DiagnosiMIB)
